import Link from "next/link";
import { connect } from "react-redux";
import { insertBaskets } from "../../../api/baskets";
import { priceComma } from "../../../common/splicePrice";
import { addToCart, increaseCnt } from "../../../redux/action/cart";
import { openQuickView } from "../../../redux/action/quickViewAction";
import { showToastAlert } from "../../../redux/action/alert";
import { useEffect, useState } from "react";
import Image from "next/image";
import {
  insertBasketsAction,
  fetchBasketsAction,
} from "../../../redux/action/baskets";
import { getCookie } from "../../../common/auth";
import * as Single from "./SingleProduct-styles";
import { ViewCountProduct } from "../../../api/products";
import { getDate } from "../../../common/util/getDate";
import { calcProdPoint } from "../../../common/helper";

const SingleProduct = ({
  product,
  basketsItems,
  cartItems,
  basketsCount,
  addToCart,
  addToWishlist,
  openQuickView,
  increaseCnt,
  showToastAlert,
  insertBasketsAction,
  fetchBasketsAction,
  dummyList,
  addCart,
  inCart,
  index,
}) => {
  const inBasket = inCart
    ? inCart(product)
    : basketsItems?.find(
        (basketsItem) => basketsItem.pcode === product.pcode
      ) || cartItems?.find((cartItem) => cartItem.pcode === product.pcode);

  // orderType 이 'O' 이거나 없으면 일반 구매 가능 상품
  const isOrderTypeO = !product.orderType || product.orderType === "O";

  const handleCart = async (product) => {
    if (product) {
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [
            {
              item_name: product.pname, // 상품 이름
              item_id: product.pcode, // 상품 ID
              price: product.price, // 상품 개별 가격
              item_brand: product.supplier, // 브랜드이름
              item_category:
                product.category_code.length > 2
                  ? product.category_code
                  : dummyList?.category[product.category_code], // 대 카테고리
            },
          ],
        },
      });

      // 채널톡 장바구니 이벤트
      window.ChannelIO("track", "AddToCart", {
        pcode: product.pcode,
      });
    }

    if (!getCookie("token")) {
      return addToCart(product);
    } else {
      return insertBasketsAction(product, 1);
    }
  };

  const moveToDetail = async () => {
    const body = {
      modes: "ViewCount",
      pcode: product.pcode,
    };
    await ViewCountProduct(body);
  };

  return (
    <>
      <Single.Wrapper>
        <Single.ProductImgWrapper>
          <Link href={`/products/${product?.ename}/${product.pcode}/`}>
            <Single.ProductImgWrapper onClick={moveToDetail}>
              <Image
                src={product.main_image}
                alt={product.pname || "상품 이미지"}
                layout="fill"
                objectFit="cover"
                sizes="(max-width: 768px) 100vw, 33vw"
                priority={index === 0}
              />
            </Single.ProductImgWrapper>
          </Link>

          {product.sfnz_view === "Y" && (
            <Single.SfnzBadge>
              <img
                src={
                  "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png"
                }
                alt="스텝포넷제로 친환경 배지"
              />
            </Single.SfnzBadge>
          )}
        </Single.ProductImgWrapper>

        <Single.ProductContentWrapper>
          <Link href={`/products/${product?.ename}/${product.pcode}/`}>
            <Single.ProductName onClick={moveToDetail}>
              {product.pname}
            </Single.ProductName>
          </Link>

          <Single.ProductBottomWrapper>
            {isOrderTypeO && (
              <Single.PriceWrapper>
                <Single.PriceBox>
                  {product.salePer > 0 && (
                    <div>
                      <span>{product.salePer}%</span>
                      <span>
                        {product.price && ` ${priceComma(product.price)}원`}
                      </span>
                    </div>
                  )}

                  <div className={"d-flex"}>
                    <h5>{priceComma(product.discount_price)}원</h5>
                  </div>

                  {Number(product.quantity) > 1 && (
                    <div
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      개당{" "}
                      {priceComma(
                        Math.floor(
                          Number(product.discount_price) /
                            Number(product.quantity)
                        )
                      )}
                      원
                    </div>
                  )}
                </Single.PriceBox>
              </Single.PriceWrapper>
            )}

            {product.sold_out === "Y" ? (
              <Single.CartIconBox>
                <span>품절</span>
              </Single.CartIconBox>
            ) : (
              <Single.CartIconBox>
                {isOrderTypeO &&
                  (!inBasket ? (
                    <a
                      className="mobonCart"
                      onClick={() =>
                        addCart ? addCart(product) : handleCart(product)
                      }
                    >
                      <i className="fi-rs-shopping-cart-add" />
                    </a>
                  ) : (
                    <a
                      onClick={() =>
                        addCart ? addCart(product) : handleCart(product)
                      }
                    >
                      <i className="fi-rs-shopping-cart-check" />
                    </a>
                  ))}
              </Single.CartIconBox>
            )}
          </Single.ProductBottomWrapper>

          <Single.StickerWrapper>
            <Single.ViewBox>
              <div>
                {priceComma(
                  calcProdPoint(
                    (Number(
                      String(product.discount_price).replace(/[^\d.-]/g, "")
                    ) || 0) * 1
                  )
                )}
                <Single.Sticker>P</Single.Sticker> 적립
              </div>
              <div>
                <img
                  src="/assets/imgs/theme/icons/icon-view.png"
                  alt="조회수 아이콘"
                />
                {product.hit}
              </div>
            </Single.ViewBox>
          </Single.StickerWrapper>
        </Single.ProductContentWrapper>
      </Single.Wrapper>
    </>
  );
};

const mapStateToProps = (state) => ({
  cartItems: state.cart,
  basketsItems: state.baskets.items,
  basketsCount: state.baskets.count,
});

const mapDispatchToProps = {
  addToCart,
  openQuickView,
  increaseCnt,
  showToastAlert,
  insertBasketsAction,
  fetchBasketsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SingleProduct);